const meta = {
  'data-model': 'Monitor data model',
  'monitor-details': 'Monitor details',
};

export default meta;
